import { firebaseApp, isProduction } from "@/services/firebase";
import router from "@/router";
import { SACServiceFactory } from "@shared";

// SAC function is temporarily deployed to us-central1 where VPC connector exists
// TODO: Move to australia-southeast1 once new IP is whitelisted
const sacFunctions = firebaseApp.functions(
  isProduction ? "us-central1" : "asia-southeast1"
);
const handleSACAPICall = sacFunctions.httpsCallable("sac-handleSACAPICall");
const sacService = SACServiceFactory.createForFrontend(
  process.env.VUE_APP_SAC_ENDPOINT,
  handleSACAPICall
);

sacService.onTokenExpired(() => router.replace({ name: "login" }));

export default sacService;
